import { add } from 'store/reducers/notifications'

export default store => next => async action => {
  if (!action.notify) return next(action)

  const defaultOptions = {
    timeout: action.notify.type === 'error' ? 12000 : 5000
  }

  let options = Object.assign({}, action.notify.options || {}, defaultOptions)

  next(add(action.notify.message, action.notify.type, options))

  return next(action)
}



// WEBPACK FOOTER //
// ./src/middleware/notify.js